import { Asterisk, ErrorAlert } from "swing-components";

import { translate } from "~utils";

import { SelectItem } from "../SelectItem";
import { SubSelectModal } from "./SubSelectModal";
import type { SubSelectProps } from "./types";

export function SubSelect(props: SubSelectProps) {
  const {
    model,
    request,
    initialSelection,
    onConfirm,
    hideCredentialToggle,
    formSubmissionErrObj,
    onFormSubmissionError,
  } = props;
  const displayValue = model.length ? `${model.length} sub(s) selected` : "";

  return (
    <SelectItem
      id="sub-select-typeahead"
      label={
        <>
          <div>
            <p css={{ margin: 0, display: "inline-block", fontSize: 16 }}>
              {translate("SUB_SELECT_HEADER")}
            </p>
            <Asterisk />
          </div>
          {formSubmissionErrObj.subs && (
            <ErrorAlert customStyles={{ alignItems: "center", fontWeight: 400 }}>
              <>{formSubmissionErrObj.subs}</>
            </ErrorAlert>
          )}
        </>
      }
      value={displayValue}
      stacked
    >
      <SubSelectModal
        hideCredentialToggle={hideCredentialToggle}
        request={request}
        trigger="sub-select-typeahead"
        title={translate("SUB_SELECT_HEADER")}
        initialSelection={initialSelection}
        onConfirm={onConfirm}
        onFormSubmissionError={onFormSubmissionError}
      />
    </SelectItem>
  );
}
